import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { Button } from '@mdvip/shared/components/ui/button';
import { AwpDocumentsModal } from '@mdvip/shared/features/awp-documents/AwpDocumentsModal';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import { awpDocumentsKey, requestMyAwpDownloadUrl } from '@/hooks/awp/awpDocumentsApi';
import { useAwpDocuments } from '@/hooks/awp/useAwpDocuments';

/** The dashboard's "Download AWP" trigger. The list is only requested once the modal first opens. */
export function AwpDocumentsButton() {
  const { t } = useTranslation('members');
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const { data, isPending, isError, refetch } = useAwpDocuments({ enabled: open });

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)}>
        <Icon name="download" size="sm" />
        {t('pages.dashboard.awpDocuments.trigger')}
      </Button>
      {open && (
        <AwpDocumentsModal
          open={open}
          onOpenChange={setOpen}
          documents={data}
          status={isPending ? 'loading' : isError ? 'error' : 'ready'}
          onRetry={refetch}
          getDownloadUrl={requestMyAwpDownloadUrl}
          onDocumentGone={() => queryClient.invalidateQueries({ queryKey: awpDocumentsKey })}
          description={[user?.firstName, user?.lastName].filter(Boolean).join(' ') || undefined}
        />
      )}
    </>
  );
}
